{
  "dodo.errors.idle.action": "다시 시도",
  "dodo.errors.idle.headline": "현재 서비스를 사용할 수 없습니다.",
  "dodo.errors.idle.line1": "나중에 다시 시도해 주세요.",
  "dodo.maintenance.actionText": "홈으로 돌아가기",
  "dodo.maintenance.description": "가끔은 핵심 유지보수 및/또는 서비스 업그레이드를 위해 짧은 휴식이 필요합니다. 양해해 주셔서 감사합니다.",
  "dodo.maintenance.headline": "죄송합니다. 현재 정기 점검 중입니다"
}